import React, { type ReactElement } from 'react'
import { getLatestSupportTicket, getSupportTicketPresentation } from '../../../../lib/helpers/support/supportTicketPresentation'
import { type IChat } from '../../../../types'

export default function SupportStatusPanel({ chat }: { chat: IChat }): ReactElement | null {
    const presentation = getSupportTicketPresentation(getLatestSupportTicket(chat.SupportTickets))
    if (presentation == null) return null

    return <div className="mx-4 mt-3 px-3 py-2 border rounded bg-light fs-7" data-testid="admin-support-status-panel">
        <div className="fw-bold">{presentation.status} · {presentation.topic} · {presentation.source ?? 'Legacy'}</div>
        <div className="text-muted mt-1">{presentation.status === 'Open' ? 'The user is waiting for support. Reply in this chat.' : 'No action required.'}</div>
    </div>
}
